import SupportV2CategoriesPage from 'features/support/flows/case-form/support-v2-categories-page';
import Pypestream from 'features/support/providers/pypestream';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export default function SupportPage() {
  const enablePypestream = useFlag(LaunchDarklyFlag.ENABLE_PYPESTREAM);
  return enablePypestream ? <Pypestream /> : <SupportV2CategoriesPage />;
}
